import React from 'react';
import { HealthMonitorButton } from './HealthMonitorButton';
import { StressMonitorButton } from '../stress/StressMonitorButton';
import { cn } from '../../utils/cn';

interface HealthMetricsSummaryProps {
  className?: string;
}

export function HealthMetricsSummary({ className }: HealthMetricsSummaryProps) {
  return (
    <div className={cn("grid grid-cols-2 gap-2", className)}>
      <HealthMonitorButton />
      <StressMonitorButton />
    </div>
  );
}